/*
 * Версии для коннектора 006 (research R4–R7, spec FR-007). Одно место для сервера, коннектора и тестов.
 */

/** Версия протокола сервер ↔ коннектор. Несовпадение — самообновление коннектора (research R24). */
export const CONNECTOR_PROTOCOL = 1;

export const AGENTS = ['claude', 'codex', 'pi'] as const;
export type AgentId = (typeof AGENTS)[number];

/** Имена агентов на экране (FR-041): без логотипов, «Claude Code» не входит в название функции. */
export const AGENT_LABEL: Readonly<Record<AgentId, string>> = { claude: 'Claude', codex: 'Codex', pi: 'pi' };

/** Нижние границы версий агентов (FR-007; research R5–R7). У Codex — точная закреплённая версия своего экземпляра. */
export const AGENT_MIN_VERSION: Readonly<Record<AgentId, string>> = {
  claude: '2.1.286',
  codex: '0.163.0',
  pi: '1.0.4',
};

/** Codex встроенного чата — свой экземпляр точной версии (research R6). */
export const CODEX_PINNED_VERSION = '0.163.0';

/** Сравнение semver `a.b.c` (хвост вида `-alpha.1` отбрасывается). */
export function compareVersions(a: string, b: string): number {
  const parse = (s: string) =>
    s
      .trim()
      .replace(/^v/u, '')
      .split(/[-+]/u)[0]
      ?.split('.')
      .map((x) => Number.parseInt(x, 10) || 0) ?? [];
  const x = parse(a);
  const y = parse(b);
  for (let i = 0; i < Math.max(x.length, y.length); i++) {
    const d = (x[i] ?? 0) - (y[i] ?? 0);
    if (d !== 0) return d < 0 ? -1 : 1;
  }
  return 0;
}

/** Первая версия `a.b.c` в выводе `--version` (`2.1.302 (Claude Code)`, `codex-cli 0.163.0`, `1.3.0`). */
export function versionIn(output: string): string | null {
  const m = /(\d+\.\d+\.\d+)/u.exec(output);
  return m?.[1] ?? null;
}

/** Агент подходит по версии: у Codex — точное совпадение, у остальных — не ниже границы. */
export function versionOk(agent: AgentId, version: string): boolean {
  if (agent === 'codex') return compareVersions(version, CODEX_PINNED_VERSION) === 0;
  return compareVersions(version, AGENT_MIN_VERSION[agent]) >= 0;
}

/** Адрес MCP-сервера табеля — точно как при входе по 005 (research R5–R7, R9). */
export const EFES_MCP_NAME = 'efes';
